<template>
  <section class="equity-results">
    <span class="result">
      <div class="result-label">Equity:</div>
      <div class="result-value" v-bind:class="equityClass">{{ (equityString + '%') || '0.00%' }}</div>
    </span>

    <span class="result win-percentage-result">
      <div class="result-label">Win:</div>
      <div class="result-value">{{ (winPercentageString + '%') || '0.00%' }}</div>
    </span>
    <span class="result tie-percentage-result">
      <div class="result-label">Tie:</div>
      <div class="result-value">{{ (tiePercentageString + '%') || '0.00%' }}</div>
    </span>
  </section>
</template>

<script>
export default {
  name: 'equity-results',
  props: ['equity', 'equityString', 'winPercentageString', 'tiePercentageString', 'hasSimulationBeenRun'],
  computed: {
    equityClass: function () {
      if (!this.hasSimulationBeenRun) {
        return '';
      }

      if (this.equity >= 95) {
        return 'green-95-100';
      } else if (this.equity >= 90) {
        return 'green-90-95';
      } else if (this.equity >= 85) {
        return 'green-85-90';
      } else if (this.equity >= 80) {
        return 'green-80-85';
      } else if (this.equity >= 75) {
        return 'green-75-80';
      } else if (this.equity >= 70) {
        return 'green-70-75';
      } else if (this.equity >= 65) {
        return 'green-65-70';
      } else if (this.equity >= 60) {
        return 'green-60-65';
      } else if (this.equity >= 55) {
        return 'green-55-60';
      } else if (this.equity > 50) {
        return 'green-50-55';
      } else if (this.equity === 50) {
        return 'gray-50';
      } else if (this.equity >= 45) {
        return 'red-45-50';
      } else if (this.equity >= 40) {
        return 'red-40-45';
      } else if (this.equity >= 35) {
        return 'red-35-40';
      } else if (this.equity >= 30) {
        return 'red-30-35';
      } else if (this.equity >= 25) {
        return 'red-25-30';
      } else if (this.equity >= 20) {
        return 'red-20-25';
      } else if (this.equity >= 15) {
        return 'red-15-20';
      } else if (this.equity >= 10) {
        return 'red-10-15';
      } else if (this.equity >= 5) {
        return 'red-5-10';
      } else if (this.equity >= 0) {
        return 'red-0-5';
      } else {
        throw new Error('Invalid value for this.equity: ', this.equity);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .equity-results {
    display: inline;
  }

  .result {
    display: inline-block;
    margin-right: 15px;

    .result-label {
      font-size: 7px;
    }

    .result-value {
      font-size: 16px;
    }
  }

  .win-percentage-result, .tie-percentage-result {
    color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/equity-results.vue